'use client'

import { IconComponent } from '@graftcode/design-system'

import { FEEDBACK_MOOD_OPTIONS } from '../mailing.const'

import type { Props } from './MoodPicker.types'

import styles from './MoodPicker.module.scss'

export function MoodPicker({ value, onChange, disabled }: Props) {
  return (
    <div className={styles.row} role="radiogroup">
      {FEEDBACK_MOOD_OPTIONS.map((option) => {
        const isSelected = value === option.value
        const buttonClassName = isSelected ? `${styles.button} ${styles.buttonSelected}` : styles.button

        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={isSelected}
            aria-label={String(option.value)}
            className={buttonClassName}
            disabled={disabled}
            onClick={() => onChange(option.value)}
          >
            <IconComponent icon={option.icon} size={24} />
          </button>
        )
      })}
    </div>
  )
}
